export const LEGACY_SUPABASE_AUTH_STORAGE_KEY = 'supabase.auth.token';

export const getSupabaseAuthStorageKey = (projectRef = '') => {
  const normalizedProjectRef = String(projectRef || '').trim();
  return normalizedProjectRef
    ? `sb-${normalizedProjectRef}-auth-token`
    : LEGACY_SUPABASE_AUTH_STORAGE_KEY;
};
